/* OS IMAGE TOGGLE — START */
/* os-image-toggle.js
   Handles the flat lay / on model image view toggle on collection PLPs.
   To remove this feature entirely, delete this file and remove the
   {% render 'os-image-toggle' %} include from sections/collection.liquid,
   plus the <script> tag loading this file from layout/theme.liquid.
*/

(function () {
  'use strict';

  /* --- Constants --- */
  var STORAGE_KEY = 'os-image-view';
  var VIEW_FLAT = 'flat';
  var VIEW_MODEL = 'model';
  var ACTIVE_CLASS = 'is-active';

  /* --- Track current active view globally within this IIFE --- */
  var currentView = VIEW_FLAT;

  /* --- Read saved preference from localStorage --- */
  function getSavedView() {
    try {
      return localStorage.getItem(STORAGE_KEY) || null;
    } catch (e) {
      return null;
    }
  }

  /* --- Save preference to localStorage --- */
  function saveView(view) {
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch (e) {
      /* localStorage unavailable — silently continue */
    }
  }

  /* --- Update body attribute for Microsoft Clarity session segmentation --- */
  function updateBodyAttr(view) {
    document.body.setAttribute('data-os-image-view', view);
  }

  /* --- Push event to dataLayer for GA4 via GTM --- */
  function pushDataLayerEvent(view) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'image_view_toggle',
      image_view_selected: view,
      page_collection: window.__osImageToggleCollection || ''
    });
  }

  /* --- Push event to Klaviyo (identified users only) --- */
  function pushKlaviyoEvent(view) {
    if (window._learnq && typeof window._learnq.push === 'function') {
      window._learnq.push(['track', 'Image View Toggle', {
        view_selected: view,
        collection: window.__osImageToggleCollection || ''
      }]);
    }
  }

  /*
   * --- Swap images on all product cards ---
   * Image 0 = flat lay shot (default in Shopify media array)
   * Image 1 = on model shot
   * Cards marked data-os-flat-only have no second image and are skipped —
   * they remain on their flat lay image regardless of view mode.
   */
  function applyView(view) {
    currentView = view;
    var cards = document.querySelectorAll('[data-os-has-second-image]');
    cards.forEach(function (card) {
      var img0 = card.querySelector('[data-grid-image="0"]');
      var img1 = card.querySelector('[data-grid-image="1"]');
      if (!img0 || !img1) return;

      if (view === VIEW_MODEL) {
        img0.classList.remove(ACTIVE_CLASS);
        img1.classList.add(ACTIVE_CLASS);
        /* Ensure lazy image inside template tag is promoted to DOM */
        promoteTemplate(img1);
      } else {
        img1.classList.remove(ACTIVE_CLASS);
        img0.classList.add(ACTIVE_CLASS);
      }
    });
  }

  /*
   * Shopify wraps non-active images in <template> tags to prevent
   * lazy loading. When we activate image 1 programmatically we need
   * to extract the template content and replace the template node.
   */
  function promoteTemplate(wrapper) {
    var tmpl = wrapper.querySelector('template');
    if (!tmpl) return;
    var content = tmpl.content.cloneNode(true);
    wrapper.replaceChild(content, tmpl);
  }

  /*
   * --- Re-assert view state on a single card after hover ---
   * The theme's hover/slideshow JS resets the active image on mouseenter.
   * We listen for mouseleave on each card and re-apply our current view,
   * so the card returns to the correct image once the user stops hovering.
   * We use mouseleave rather than fighting mouseenter timing.
   */
  function bindHoverCorrection(card) {
    card.addEventListener('mouseleave', function () {
      if (currentView === VIEW_MODEL) {
        var img0 = card.querySelector('[data-grid-image="0"]');
        var img1 = card.querySelector('[data-grid-image="1"]');
        if (!img0 || !img1) return;
        img0.classList.remove(ACTIVE_CLASS);
        img1.classList.add(ACTIVE_CLASS);
      }
      /* In flat view the theme default is correct — no correction needed */
    });
  }

  /* --- Update toggle button active states --- */
  function updateToggleUI(view) {
    var toggles = document.querySelectorAll('[data-os-toggle]');
    toggles.forEach(function (el) {
      var btnFlat = el.querySelector('[data-os-view="flat"]');
      var btnModel = el.querySelector('[data-os-view="model"]');
      if (!btnFlat || !btnModel) return;

      if (view === VIEW_MODEL) {
        btnFlat.classList.remove('os-toggle__btn--active');
        btnModel.classList.add('os-toggle__btn--active');
        btnFlat.setAttribute('aria-pressed', 'false');
        btnModel.setAttribute('aria-pressed', 'true');
      } else {
        btnModel.classList.remove('os-toggle__btn--active');
        btnFlat.classList.add('os-toggle__btn--active');
        btnFlat.setAttribute('aria-pressed', 'true');
        btnModel.setAttribute('aria-pressed', 'false');
      }
    });
  }

  /* --- Handle a toggle click --- */
  function handleToggleClick(view) {
    applyView(view);
    updateToggleUI(view);
    saveView(view);
    updateBodyAttr(view);
    pushDataLayerEvent(view);
    pushKlaviyoEvent(view);
  }

  /* --- Initialise --- */
  function init() {
    var toggleContainer = document.querySelector('[data-os-toggle]');
    if (!toggleContainer) return; /* Toggle not present on this collection */

    var defaultView = toggleContainer.getAttribute('data-os-default') || VIEW_FLAT;
    var savedView = getSavedView();
    var activeView = (savedView === VIEW_FLAT || savedView === VIEW_MODEL) ? savedView : defaultView;

    /* Apply view and UI immediately on load */
    applyView(activeView);
    updateToggleUI(activeView);
    updateBodyAttr(activeView);

    /* Bind hover correction to all cards that have a second image */
    var cards = document.querySelectorAll('[data-os-has-second-image]');
    cards.forEach(function (card) {
      bindHoverCorrection(card);
    });

    /* Bind click events to toggle buttons */
    var buttons = document.querySelectorAll('[data-os-toggle] [data-os-view]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-os-view');
        handleToggleClick(view);
      });
    });
  }

  /* Run on DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
/* OS IMAGE TOGGLE — END */
